/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Button,
    Stack,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'

const PageActionPlaceHolder = ({
    heading,
    text,
    icon,
    buttonText,
    buttonProps,
    onButtonClick,
    variant,
}) => {
    const styles = useMultiStyleConfig('Wishlist', {variant: variant})
    return (
        <Stack {...styles.pageActioncontainer}>
            <Box {...styles.iconContainer}>{icon}</Box>
            <Stack {...styles.container}>
                <Box {...styles.textContainer}>
                    <Text {...styles.heading}>{heading}</Text>
                    <Text {...styles.text}>{text}</Text>
                </Box>
                <Button
                    variant="outline"
                    onClick={onButtonClick}
                    {...buttonProps}
                    {...styles.addButton}
                >
                    {buttonText}
                </Button>
            </Stack>
        </Stack>
    )
}

PageActionPlaceHolder.propTypes = {
    heading: PropTypes.string,
    text: PropTypes.string,
    buttonText: PropTypes.string,
    icon: PropTypes.any,
    buttonProps: PropTypes.object,
    onButtonClick: PropTypes.func,
    variant: PropTypes.string,
}

export default PageActionPlaceHolder
